import styled, { css } from 'styled-components';
import { breakpoint, font } from 'styles/globals';
import { type Theme, getColor } from 'styles/theme';

export const Wrapper = styled.div<{ theme: Theme }>`
  margin-top: 48px;
  padding: 0 20px 40px;
  position: relative;
  color: ${getColor('neutralBlack')};
  font-family: ${font.graphikCond};
  font-weight: 400;
  letter-spacing: 0.5px;
  margin: 8px 16px 0px;

  @media (${breakpoint.mdMin}) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 32px;
    padding: 0;
    margin: 0 24px 0px;
  }

  .modal-wrapper {
    width: 288px;

    #modalTitle {
      margin: auto;
    }

    #modalContent {
      padding: 0;
      text-align: center;
    }

    button {
      padding: 8px 16px;
      font-family: ${font.graphikCond};
      font-size: 14px;
      font-weight: 600;
      line-height: 21px;
      letter-spacing: 0.5px;
    }

    @media (${breakpoint.mdMin}) {
      width: 508px;
      button {
        padding: 16px 32px;
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
`;

export const Heading = styled.div<{ theme: Theme }>`
  border-left: 4px solid ${getColor('brandSecondary')};
  padding-left: 16px;
  font-family: ${font.saolText};
  font-size: 24px;
  font-weight: 600;
  line-height: 120%;

  @media (${breakpoint.mdMin}) {
    justify-self: start;
  }

  @media (${breakpoint.lgMin}) {
    font-size: 32px;
  }
`;

export const CTAButton = styled.button<{ theme: Theme }>`
  display: flex;
  gap: 8px;
  align-items: center;
  color: ${getColor('neutralDarkGray')};
  font-family: ${font.graphikCond};
  font-size: 16px;
  font-weight: 600;
  line-height: 120%;

  svg {
    stroke: ${getColor('neutralDarkGray')};
    width: 12px;
    height: 12px;
  }

  @media (${breakpoint.mdMax}) {
    position: absolute;
    bottom: 0;
    right: 20px;
  }

  @media (${breakpoint.mdMin}) {
    justify-self: end;
  }
`;

export const ListAndImageWrapper = styled.div`
  @media (${breakpoint.mdMin}) {
    grid-column: span 2;
    display: flex;
    flex-direction: row-reverse;
  }
`;

export const NewslettersImage = styled.div<{ isOneRow: boolean; theme: Theme }>`
  aspect-ratio: 220/101;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, 0.00) 30%), 
  url('/icons/SalesMarketing/CEODaily.png') 18.889px 0px / 88.889% 392.217% no-repeat;
  margin: 24px -20px;

  @media (${breakpoint.mdMin}) {
    height: 500px;
    aspect-ratio: 246.83/500.00;
    margin: 0 40px;
    background: url('/icons/SalesMarketing/CEODaily.png') 50% / cover no-repeat;
  }

  @media (${breakpoint.lgMin}) {
    margin: 0 72px;

    ${(props) =>
      props.isOneRow &&
      css<{ theme: Theme }>`
        background: url('/icons/SalesMarketing/CEODaily.png') ${getColor('neutralLightGray2')} 1.87px 9.345px / 100% 209.205% no-repeat;
        height: 239px;
        aspect-ratio: 247/239;
        border-radius: 38px;
        border: 12px solid ${getColor('neutralLightGray2')};
        border-bottom: none;
        border-top: 4px solid ${getColor('neutralLightGray2')};
      `}
  }
`;

export const NewsletterListWrapper = styled.div<{ columnsCount: number }>`
  display: flex;
  gap: 32px;
  flex-direction: column;

  @media (${breakpoint.mdMin}) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 24px;
    row-gap: 48px;
  }

  @media (${breakpoint.lgMin}) {
    grid-template-columns: ${({ columnsCount }) => (columnsCount > 2 ? '1fr 1fr 1fr' : columnsCount === 2 ? '1fr 1fr' : '1fr')};
  }
`;

export const Frequency = styled.div`
  font-size: 14px;
  line-height: 150%;
  text-transform: uppercase;
`;

export const Title = styled.div`
  font-size: 24px;
  font-weight: 600;
  line-height: 120%;
  margin: 4px 0;
`;

export const AuthorWrapper = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 1.2px;
  margin-bottom: 16px;
`;

export const Author = styled.div`
  font-weight: 600;
  line-height: 120%;
`;

export const Excerpt = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  font-size: 16px;
  line-height: 150%;
  margin-bottom: 24px;
`;

export const Button = styled.button<{ theme: Theme; isSubscribed: boolean }>`
  display: flex;
  justify-content: center;
  height: 48px;
  width: 100%;
  padding: 12px 16px;
  background: ${({ isSubscribed }) => (isSubscribed ? getColor('neutralBlack') : getColor('brandSecondary'))};
  cursor: ${({ isSubscribed }) => (isSubscribed ? 'default' : 'pointer')};
  color: ${getColor('neutralWhite')};
  font-family: ${font.graphikCond};
  font-size: 16px;
  font-weight: 600;
  line-height: 150%;
  border-radius: 999px;
  
`;
